const UpdatesIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.3 14.8101L15.7 16.7701C15.92 17.8501 15.23 18.9101 14.14 19.1301L10.22 19.9401C9.13996 20.1601 8.07996 19.4701 7.85996 18.3801L7.45996 16.4201"
            stroke="#CBCBCB"
            stroke-miterlimit="10"
        />
        <path d="M2 15.23L3.31 17.93L15.09 5.56003L14.66 4.66003L2 15.23Z" fill="white" />
        <path d="M15.0901 5.56006L3.31006 17.9301L3.74006 18.8301L18.8801 13.3701L15.0901 5.56006Z" fill="#E8E8E8" />
        <path d="M18.88 13.3701L3.73999 18.8301L19.89 15.4601L18.88 13.3701Z" fill="#CBCBCB" />
        <path
            d="M15.5599 4.22004C15.3199 3.72004 14.7199 3.52004 14.2199 3.76004C13.7199 4.00004 13.5199 4.60004 13.7599 5.10004L18.9899 15.9C19.2299 16.4 19.8299 16.6 20.3299 16.36L15.0999 5.56004C14.8599 5.06004 15.0699 4.46004 15.5599 4.22004Z"
            fill="#DA5457"
        />
        <path
            d="M2.9 14.8C2.66 14.3 2.06 14.1 1.56 14.34C1.06 14.58 0.860004 15.18 1.1 15.68L2.84 19.28C3.08 19.78 3.68 19.98 4.18 19.74L2.44 16.14C2.2 15.64 2.41 15.04 2.9 14.8Z"
            fill="#DA5457"
        />
        <path
            d="M20.79 15.0201L15.56 4.22009C15.06 4.46009 14.86 5.06009 15.1 5.56009L20.33 16.3601C20.83 16.1201 21.03 15.5201 20.79 15.0201Z"
            fill="#B23A38"
        />
        <path
            d="M4.64009 18.4L2.90009 14.8C2.40009 15.04 2.20009 15.64 2.44009 16.14L4.18009 19.74C4.68009 19.5 4.88009 18.9 4.64009 18.4Z"
            fill="#B23A38"
        />
        <path d="M21.35 8.22998L19.54 9.09998" stroke="#CBCBCB" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M18.47 6.73999L19.59 5.73999" stroke="#CBCBCB" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M22.2 11.15L20.72 11.4" stroke="#CBCBCB" stroke-miterlimit="10" stroke-linecap="round" />
    </svg>
)

UpdatesIcon.displayName = 'UpdatesIcon'

export default UpdatesIcon
